/**
 * 보미건설 상표(CI)와 문서 레터헤드에 쓰는 상수 (DOC-51).
 *
 * 상호·주소·색이 화면마다 흩어지면 상호가 바뀔 때 <b>화면과 출력물이 서로 다른 회사</b>가 된다.
 * 값은 사내 표준 양식(`docs/samples/★BM-…샘플문서.pdf`)과 CI 원본에서 그대로 뽑았다.
 */

/** CI 이미지(배경 투명 PNG). 인쇄에서 사라지지 않도록 <b>CSS 배경이 아니라 `<img>`</b> 로 쓴다. */
export const CI_SRC = '/brand/bomi-ci.png';

/**
 * `Lounge` 워드마크(배경 투명 PNG · 553×170). 원본 `docs/samples/loungeCI_3.png`.
 *
 * 원본에서 둘을 고쳐 구웠다(2026-09-11). ① 배경이 <b>흰색이 아니라 미색</b>(`rgb(247,247,243)`)이라
 * 흰 헤더 위에 크림색 네모가 드러났다 — 그 색을 알파로 되풀었다. ② 위아래 빈 줄을 잘라 냈다.
 * 자르고 나면 <b>기준선이 그림 높이의 0.744</b> 자리에 온다(나머지는 `g` 의 내림). 그 값이
 * {@code BrandMark} 가 `BoMI` 와 발을 맞추는 데 쓰는 상수다.
 *
 * <b>맨 끝 `e` 는 원본에서 오른쪽이 잘려 있다.</b> 되살릴 수 없어 그대로 두었다.
 *
 * `BoMI` 와 한 장에 그린 `loungeCI.png` 는 쓰지 않는다 — 빨간 `B` 가 공식 CI 보다 23% 넓고
 * (글자폭÷M폭 0.960 대 0.779) 낱말 사이가 글자 사이와 같아 한 낱말로 읽혔다.
 */
export const LOUNGE_SRC = '/brand/lounge-wordmark.png';

export const COMPANY = {
  name: '(주)보미건설',
  /** 레터헤드 주소줄 — 우편번호·주소·층·홈페이지가 한 줄이다. */
  addressLine: '(주)보미건설  02830 서울시 성북구 동소문로89 보미타워 3F, 5F / www.bomienc.com',
  site: 'www.bomienc.com',
  /**
   * 레터헤드 우측 상단. 두 줄로 쌓인다 — <b>윗줄은 먹색, 아랫줄만 적색</b>이다(CI 원본).
   * 「NO.1」 은 「WORLD BEST」 폭의 가운데에 선다(`ApprovalDocumentView` ①).
   */
  tagline: { top: 'WORLD BEST', bottom: 'NO.1' },
  /** 문서 하단 슬로건. */
  slogan: '<< 역사를 넘어 혁신으로 >>',
} as const;

/** 원본에서 추출한 색 — CI 적색, 레터헤드 굵은 줄, 결재란 라벨 배경. */
export const BRAND_COLOR = {
  red: '#A00F16',
  rule: '#5F6663',
  boxLabelBg: '#DBEBF8',
  ink: '#111',
  line: '#222',
} as const;
